(function () {
  'use strict';
  var node = document.getElementById('onair-launch-config');
  if (!node) return;
  var config;
  try { config = JSON.parse(node.textContent); } catch (_) { return; }
  var params = new URLSearchParams(location.search);
  var themePreview = config.production !== true;
  config.production = config.production === true && !params.has('preview_theme_id') && params.get('onair_qa') !== '1' && !location.hostname.endsWith('.shopifypreview.com');
  var loaded = performance.now();
  var serverNow = Number(config.serverNow);
  function now() { return Number.isFinite(serverNow) ? serverNow + performance.now() - loaded : Date.now(); }
  function state() {
    if (!config.production) return themePreview ? 'preview' : 'qa';
    if (!config.campaignApproved) return 'regular';
    var start = Number(config.startsAtMs), end = Number(config.endsAtMs);
    var explicitTime = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:Z|[+-]\d{2}:\d{2})$/;
    if (config.windowValid !== true || !explicitTime.test(config.startsAt) || !explicitTime.test(config.endsAt) || !Number.isFinite(serverNow) || !Number.isSafeInteger(start) || !Number.isSafeInteger(end) || end - start !== 1555200000 || !String(config.discountId || '').trim() || !['all_2v','base_only'].includes(config.scope)) return 'blocked';
    if (now() < start) return 'scheduled';
    return now() < end ? 'active' : 'expired';
  }
  function eligible(tier, key) { return config.marketEligible === true && tier === 'essential' && (config.scope === 'all_2v' || (config.scope === 'base_only' && key === config.baseKey)); }
  function priceMinor(tier, key, regularMinor, currency) {
    if (!Number.isSafeInteger(regularMinor) || regularMinor <= 0) return null;
    var mode = state();
    return currency === config.currency && eligible(tier, key) && (mode === 'preview' || mode === 'active') ? Math.max(0, regularMinor - config.discountMinor) : regularMinor;
  }
  function money(minor, currency) {
    currency = currency || config.currency;
    return new Intl.NumberFormat('en-CA', {style:'currency',currency:currency,currencyDisplay:'narrowSymbol',maximumFractionDigits:2,minimumFractionDigits:0}).format(minor / 100) + ' ' + currency;
  }
  function render() {
    var mode = state(), promo = config.marketEligible === true && (mode === 'preview' || mode === 'active');
    document.documentElement.dataset.onairLaunchState = mode;
    document.querySelectorAll('[data-onair-launch-price]').forEach(function (item) {
      var regular = Number(item.dataset.regularMinor || config.baseRegularMinor);
      var amount = priceMinor(item.dataset.tier || 'essential', item.dataset.variantKey || config.baseKey, regular, item.dataset.currency || 'CAD');
      if (amount !== null) item.textContent = money(amount, item.dataset.currency || 'CAD');
    });
    document.querySelectorAll('[data-onair-launch-label]').forEach(function (item) {
      var value = promo ? item.dataset.promo : item.dataset.regular;
      if (value) item.textContent = value;
    });
    document.querySelectorAll('[data-onair-launch-promo-only]').forEach(function (item) { item.hidden = !promo; });
    document.querySelectorAll('[data-onair-launch-active-only]').forEach(function (item) { item.hidden = !promo || mode !== 'active'; });
    document.querySelectorAll('[data-onair-launch-preview-only]').forEach(function (item) { item.hidden = mode !== 'preview'; });
    document.querySelectorAll('[data-onair-launch-deadline]').forEach(function (item) {
      item.hidden = !promo || mode !== 'active';
      if (mode === 'active' && promo) item.textContent = new Intl.DateTimeFormat('en-CA',{timeZone:config.timezone,month:'short',day:'numeric',year:'numeric',hour:'numeric',minute:'2-digit',timeZoneName:'short'}).format(new Date(config.endsAt));
    });
    if (config.lastState !== mode) {
      config.lastState = mode;
      document.dispatchEvent(new CustomEvent('onair:launch-state-change', {detail:{state:mode}}));
    }
  }
  config.state = state;
  config.isEligible = eligible;
  config.priceMinor = priceMinor;
  config.now = now;
  Object.defineProperty(config, 'campaignActive', {get:function () { return config.marketEligible === true && state() === 'active'; }});
  window.ONAIR_LAUNCH = config;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render, {once:true}); else render();
  document.addEventListener('shopify:section:load', render);
  window.addEventListener('pageshow', render);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) render(); });
  setInterval(function () { if (config.lastState !== state()) render(); }, 1000);
})();
